import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { Task } from '@src/app/models/task';

@Injectable({
  providedIn: 'root'
})
export class AdhoctaskService {

  constructor(private http: HttpClient) { }

  createAdhocTask(task: Task) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.post<string>(
      environment.apiUrl + '/organization/' + SessionHelper.getChoosenOrg() + '/tasks/adhoc',
      task,
      httpOptions
    );
  }

  updateAdhocTask(task: Task) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.put<string>(
      environment.apiUrl + '/organization/' + SessionHelper.getChoosenOrg() + '/tasks/adhoc/' + task.taskId,
      task,
      httpOptions
    );
  }

  deleteAdhocTask(task: Task) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.delete<string>(
      environment.apiUrl + '/organization/' + SessionHelper.getChoosenOrg() + '/tasks/adhoc/' + task.taskId,
      httpOptions
    );
  }
}
